import AfterCoverLink from '@/components/after-cover-link'
import Blocks from '@/components/blocks'
import Cover from '@/components/cover'
import Kpi from '@/components/kpi'
import PushCase from '@/components/push-case'
import PushLink from '@/components/push-link'
import PushPartner from '@/components/push-partner'
import PushPost from '@/components/push-post'
import SliderPartner from '@/components/slider-partner'
import TitleAnimation from '@/components/ui/title-animation'
import LinkAnimation from '@/components/ui/link-animation'
import TextAnimation from '@/components/ui/text-animation'
import HashtagAnimation from '@/components/ui/hashtag-animation'
import ImageAnimation from '@/components/ui/image-animation'
import CaseLinkAnimation from '@/components/ui/case-link-animation'
import WebglHeader from '@/components/ui/webgl-header'

import Wysiwyg from '@/components/wysiwyg'

export default {
  components: {
    AfterCoverLink,
    Blocks,
    Cover,
    Kpi,
    PushCase,
    PushLink,
    PushPartner,
    PushPost,
    SliderPartner,
    TitleAnimation,
    LinkAnimation,
    TextAnimation,
    HashtagAnimation,
    ImageAnimation,
    CaseLinkAnimation,
    WebglHeader,
    Wysiwyg
  }
}
